import {AbstractStorageModule} from "@/services/storage/AbstractStorageModule";

export class Page extends AbstractStorageModule {
  type: null|string = null;
  source: null|string = null;

  types = {
    checkoutPayment: 'checkoutPayment',
    checkoutShippingMethod: 'checkoutShippingMethod',
    checkoutSuccess: 'checkoutSuccess',
    product: 'product',
    order: 'order',
    cart: 'cart',
    offer: 'offer',
  };

  sources = {
    shopifyCheckoutPage: 'shopify.checkout.page',
    shopifyAnalyticsMetaPagePath: 'shopify.analytics.meta.page.path',
    shopifyAnalyticsMetaPageType: 'shopify.analytics.meta.page.pageType',
    shopifyCheckoutStep: 'shopify.checkout.step',
    pageUrl: 'page.url',
  };

  resolve() {

    this.type = null;
    this.source = null;

    // by checkout page
    // @ts-ignore
    let checkout = window?.Shopify?.Checkout;
    let checkoutPage = checkout?.page ?? null;
    if(checkoutPage && checkoutPage === "thank_you") {
      this.type = this.types.checkoutSuccess;
      this.source = this.sources.shopifyCheckoutPage;
      return;
    }

    // by checkout step
    let checkoutStep = checkout?.step ?? null;
    if(checkoutPage === 'show' && checkoutStep) {
      const checkoutStepTypeMap = {
        'payment_method': this.types.checkoutPayment,
        'shipping_method': this.types.checkoutShippingMethod,
      };
      if(checkoutStep in checkoutStepTypeMap) {
        this.type = checkoutStepTypeMap[checkoutStep];
        this.source = this.sources.shopifyCheckoutStep;
        return;
      }
    }

    // @ts-ignore
    const pageMeta = window?.ShopifyAnalytics?.meta?.page ?? {};

    // by analytics meta pageType
    let type = pageMeta?.pageType ?? null;
    if(type) {
      const pageMetaTypeMap = {
        // 'home': null,
        // 'collection': null,
        'product': this.types.product,
      };
      if(type in pageMetaTypeMap) {
        this.type = pageMetaTypeMap[type];
        this.source = this.sources.shopifyAnalyticsMetaPageType;
        return;
      }
    }

    // by analytics page meta path
    let path = pageMeta?.path ?? null;
    if (path) {
      const pathTypeMap = {
        '/thank_you': this.types.checkoutSuccess,
        '/checkout/payment': this.types.checkoutPayment,
        '/checkout/shipping': this.types.checkoutShippingMethod,
      };
      let typeByPageMetaPath: string|null = null;
      Object.entries(pathTypeMap).forEach(([pathPart, pageType]) => {
        if (path.indexOf(pathPart) === -1) return;
        typeByPageMetaPath = pageType;
      });
      if(typeByPageMetaPath) {
        this.type = typeByPageMetaPath;
        this.source = this.sources.shopifyAnalyticsMetaPagePath;
        return;
      }
    }

    // by url
    const pathname = window.location.pathname;
    const urlTypeMap = {
      // any product page
      '/products/': this.types.product,
      // authenticated customer is redirected here after checkout
      '/thank_you': this.types.checkoutSuccess,
      // not authenticated customer will be redirected here after checkout
      // authenticated customer can access it from ORDER HISTORY
      '/orders/': this.types.order,
      // cart page
      '/cart': this.types.cart,
      // payment page
      '/checkout/payment': this.types.checkoutPayment,
      // offer page
      'offers': this.types.offer,
    };
    let typeByUrl: string|null = null;
    Object.entries(urlTypeMap).forEach(([urlPart, pageType]) => {
      if (pathname.indexOf(urlPart) === -1) return;
      typeByUrl = pageType;
    });
    if(typeByUrl) {
      this.type = typeByUrl;
      this.source = this.sources.pageUrl;
      return;
    }
  }
}